/* import __COLOCATED_TEMPLATE__ from './credit-pack-contents-list.hbs.js'; */
import Component from '@glimmer/component';

// This component is used to display the contents of a credit pack,
// which is a list of items and item variations that are allowed to be
// redeemed for a package based on its pricing rule.

// A pricing rule has a list of allowed items, and a list of allowed item
// variations; these lists are completely independent of each other. To reduce
// confusion, we don't allow any kind of duplication between the two lists. If
// an item is in the Allowed Items list then none of its variations should be in
// the Allowed Item Variations list. If an item variation is in the Allowed Item
// Variations list then its parent item should not be in the Allowed Items list.

// This component will first list every item in the Allowed Items list. If that
// item has more than one variation, we will also say "all variations" so that
// the merchant doesn't get confused and think that the credit pack can only be
// redeemed for some of its variations.

// This component will then list every item variation in the Allowed Item
// Variations list. To give context we group the variations by their parent
// item. For example, we could have two item variations for two different items
// both named "Regular"; we need to include the item name to make it clear to
// the merchant which specific variations they've included in the credit pack.

export default class CreditPackContentsList extends Component {
  get allowedItemVariationsSummary() {
    const itemIdToItemNameAndVariationNames = {};
    this.args.allowedItemVariations.forEach(variation => {
      if (itemIdToItemNameAndVariationNames[variation.itemId]) {
        itemIdToItemNameAndVariationNames[variation.itemId].variationNames.push(variation.name);
      } else {
        itemIdToItemNameAndVariationNames[variation.itemId] = {
          name: variation.itemName,
          variationNames: [variation.name]
        };
      }
    });
    return Object.values(itemIdToItemNameAndVariationNames);
  }
}